import './App.css';
import Home from "./pages/home";
import Project from "./pages/project";
import Authentication from './pages/authentication';
import Navbar from './components/navbar/navebar';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { database } from './utils/fipresConfig';
import { useEffect, useState } from 'react';
import Notes from './pages/notes';
import Files from './pages/files'; // استيراد ملفات
import Admin from './pages/admin'; // استيراد Admin
import { RotatingLines } from 'react-loader-spinner';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./utils/fipresConfig";
import { doc, getDoc } from "firebase/firestore";

export default function App() {
  const [title, setTitle] = useState("");
  const [editData, setEditData] = useState(null); // حالة لتخزين البيانات التي سيتم تحريرها
  const [loading, setLoading] = useState(true); // حالة التحميل
  const location = useLocation();
  const navigate = useNavigate();
  const [user, userLoading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const titelRef = collection(database, "books");
    const q = query(titelRef, where("primaryKey", "==", "news"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const getTitle = snapshot.docs.map((doc) => doc.data().title);
      setTitle(getTitle);
      setLoading(false); // تعيين حالة التحميل إلى false بعد تحميل البيانات
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        const docRef = doc(database, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();
          setIsAdmin(userData.isAdmin === true);
        }
      }
    };
    fetchUserRole();
  }, [user]);

  useEffect(() => {
    if (!user && !userLoading && (location.pathname === '/admin' || location.pathname === '/notes')) {
      navigate('/authentication');
    } else if (user && !isAdmin && location.pathname === '/admin') {
      navigate('/');
      
    }
  }, [user, userLoading, isAdmin, location, navigate]);

  const handleEditClick = () => {
    setEditData({ title }); // تحديث حالة editData بالنص الحالي
    document.getElementById("admin-form").scrollIntoView({ behavior: "smooth" }); // رفع الشاشة إلى النموذج
  };

  if (loading || userLoading) {
    return (
      <div className='title__Loading'>
        <RotatingLines
          visible={true}
          height="60"
          width="60"
          strokeColor="#1d1b22"
          strokeWidth="5"
          animationDuration="0.75"
          ariaLabel="rotating-lines-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    ); // عرض رسالة التحميل أثناء تحميل البيانات
  }

  return (
    <>
      <Navbar className="section" />
      <div>
        <p className="text_title"> {title}</p>
        <hr className='hr' />
        {location.pathname === '/admin' && (
          <div className="title__titlec">
            <button className="edit-button" id="title__title" onClick={handleEditClick}>
              Edit
            </button>
          </div>
        )}
      </div>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/project' element={<Project className="section" />} />
        <Route path='/files' element={<Files />} /> {/* استخدام ملفات هنا */}
        <Route path='/notes' element={<Notes />} />
        <Route path='/authentication' element={<Authentication />} />
        <Route path='/admin' element={<Admin editData={editData} />} /> {/* تمرير editData إلى Admin */}
      </Routes>
    </>
  );
}
